import '@babel/polyfill'
import 'mutationobserver-shim'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuesax from 'vuesax'
import './plugins/bootstrap-vue'
import 'vuesax/dist/vuesax.css'
import 'boxicons/css/boxicons.css'
import '@fortawesome/fontawesome-free/css/all.css'

import App from './App'
import router from './router'

Vue.use(Vuesax, {
  // options here
})

/*
Vue.use(VCalendar, {
})
*/
let rotaAnterior = null

router.beforeEach((to, from, next) => {
  // Armazenar a rota anterior antes de cada navegação
  // eslint-disable-next-line no-unused-vars
  console.log(from)
  rotaAnterior = from
  next()
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})

Vue.prototype.$rotaAnterior = rotaAnterior



// WEBPACK FOOTER //
// ./src/main.js